import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';

import { ButtonComponent, TiimeButtonModule, TiimeIconModule, TiimeTooltipModule } from 'tiime-material';

import { Company } from '@models/company';
import { AppRoute } from '@modules/core/navigation/app-route.enum';
import { NavigationService } from '@modules/core/navigation/navigation.service';
import { CompanyCellComponent } from '@shared-cells/company-cell/company-cell.component';
import { CompanyStatusComponent } from '@shared-components/company-status/company-status.component';
import { CompanyUsersContactsComponent } from '@shared-components/company-users-contacts/company-users-contacts.component';
import { CompanyOverviewOverlayService } from '@shared-overlays/company-overview-overlay/company-overview-overlay.service';
import { IncludesPipe } from '@shared-pipes/includes/includes.pipe';

export type CompanyOptionColumns = 'status' | 'company' | 'contacts' | 'overviewButton' | 'openInNewTab';

@Component({
  selector: 'app-company-option',
  standalone: true,
  imports: [
    TiimeButtonModule,
    TiimeIconModule,
    TiimeTooltipModule,
    IncludesPipe,
    CompanyCellComponent,
    CompanyUsersContactsComponent,
    CompanyStatusComponent
  ],
  templateUrl: './company-option.component.html',
  styleUrls: ['./company-option.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'tiime-option'
  }
})
export class CompanyOptionComponent {
  @Input() company: Company;
  @Input() displayedColumns: CompanyOptionColumns[] = ['status', 'company', 'contacts', 'overviewButton'];

  @ViewChild('overviewAnchor') overviewAnchor: ButtonComponent;

  constructor(
    private readonly companyOverviewOverlayService: CompanyOverviewOverlayService,
    private readonly navigationService: NavigationService
  ) {}

  openCompanyOverview(): void {
    this.companyOverviewOverlayService
      .open(
        { companyId: this.company.id, insideCompany: false },
        {
          connectTo: {
            origin: this.overviewAnchor.elementRef,
            positions: [
              {
                originX: 'start',
                originY: 'bottom',
                overlayX: 'start',
                overlayY: 'top',
                offsetY: 8
              }
            ]
          }
        }
      )
      .afterClosed()
      .subscribe();
  }

  openInNewTab(): void {
    this.navigationService.openInNewTab([AppRoute.companies, this.company.id]);
  }
}
